export const versionSettings = {
  "1.0": {
    table_count: 45,
    //hide_table: [
    //  {
    //    route: "technology",
    //    children: ["input_scen_curtailment"],
    //  },
    //],
    hide_columns: [
      {
        route: "battery",
        columns: ["IS_VPP"],
      },
    ],
  },
  "2.0": {
    table_count: 45,
  },
};
